import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';
import gsap from 'gsap';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsStockInfoHistoricalQuoteHeaderCls: string;
			investorsStockInfoHistoricalQuoteQuoteDataCls: string;
		},

		investorsStockInfoHistoricalQuoteDataSelectorInputLookupDateId?: string;
		investorsStockInfoHistoricalQuoteQuoteDataInnerCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataDisclaimerCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataDisclaimerItemInnerCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataDaysOpen?: string;
		investorsStockInfoHistoricalQuoteQuoteDataClosingPriceCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataIntradayLowCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataIntradayHighCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataVolumeCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataButtonsWrapperCls?: string;
		investorsStockInfoHistoricalQuoteQuoteLookupDateDataButtonsWrapperCls?: string;
		quoteDataInnerLoadingCls?: string;
		dataSelectorButtonsButtonsWrapperLoadingCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataButtonCls?: string;
		buttonPrimaryActiveCls?: string;
		investorsStockInfoHistoricalQuoteQuoteDataAreaCls?: string;
		quoteDataAreaActiveCls?: string;
		investorsStockInfoHistoricalQuoteLookupDateButtonCls?: string;
		investorsStockInfoHistoricalQuoteLookupFormId?: string;
	},

	apiStockEndpoint?: string;
	slug: string
}

class HistoricalQuote extends Module {

	publicVars: OptionsInterface;
	privateVars: {
		inputDateSelectorHtml: null | HTMLInputElement;
		currentSelectedDate: null | string;
		currentTicker: string | null;
		tickers: {
			plsrl: 'plsrl';
			plsrv: 'plsrv';
			psrhf: 'psrhf';
		},
		animating: boolean;
	} = {
		inputDateSelectorHtml: null,
		currentSelectedDate: null,
		currentTicker: null,
		tickers: {
			plsrl: 'plsrl',
			plsrv: 'plsrv',
			psrhf: 'psrhf',
		},
		animating: true,
	}

	constructor(options: OptionsInterface) {
		super('Investors Stock Info Historical Quote Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoHistoricalQuoteHeaderCls || '', 'investors_stock_info_historical_quote', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoHistoricalQuoteQuoteDataCls || '', 'investors_stock_info_historical_quote', { animCls: 'animate__fadeIn', once: true});

		if(this.publicVars.cssId.investorsStockInfoHistoricalQuoteDataSelectorInputLookupDateId) {
			this.privateVars.inputDateSelectorHtml = document.querySelector(this.publicVars.cssId.investorsStockInfoHistoricalQuoteDataSelectorInputLookupDateId) as HTMLInputElement;

			this.privateVars.currentSelectedDate = this.privateVars.inputDateSelectorHtml.value;
		}

		this.updateStockData(this.privateVars.currentSelectedDate);
	}

	bind() {
		this.msg('bind');

		const buttonsHtml = document.querySelectorAll<HTMLElement>(this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataButtonCls || '');

		buttonsHtml.forEach(button => {
			if(button.classList.contains(this.publicVars.cssId.buttonPrimaryActiveCls?.substring(1) || '')) {
				this.privateVars.currentTicker = button?.dataset['ticker'] || 'plsrl';
			}

			button.addEventListener('click', e => {

				const target = e.currentTarget;

				if(target instanceof HTMLElement) {
					const ticker = target.dataset.ticker;

					if(ticker) {
						this.handleButtonClick(ticker);
					}
				}
			})
		});

		// const lookupDateButton = document.querySelector(this.publicVars.cssId.investorsStockInfoHistoricalQuoteLookupDateButtonCls || '');
		//
		// if(lookupDateButton) {
		// 	lookupDateButton.addEventListener('click', () => {
		// 		this.handleLookupDateBtnClick();
		// 	})
		// }

		const lookupFormHtml = document.querySelector(
			this.publicVars.cssId.investorsStockInfoHistoricalQuoteLookupFormId || '');

		if (lookupFormHtml) {
			lookupFormHtml.addEventListener('submit', (e) => {
				e.preventDefault();

				this.handleLookupDateBtnClick();
			});
		}
	}

	handleLookupDateBtnClick() {
		if(this.privateVars.animating || !this.privateVars.inputDateSelectorHtml) {
			return;
		}

		this.handleLoadingStateHelper(true);

		if(this.privateVars.currentSelectedDate === this.privateVars.inputDateSelectorHtml.value) {
			setTimeout(() => this.handleLoadingStateHelper(), 500);
			return;
		}

		this.privateVars.currentSelectedDate = this.privateVars.inputDateSelectorHtml.value;

		this.updateStockData(this.privateVars.currentSelectedDate);
	}

	handleButtonClick(ticker: string) {
		if(this.privateVars.animating) {
			return;
		}

		const currentAreaHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataAreaCls}-${this.privateVars.currentTicker}`) as HTMLElement;
		const nextAreaHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataAreaCls}-${ticker}`) as HTMLElement;

		if(!currentAreaHtml || !nextAreaHtml) {
			return;
		}

		if(this.privateVars.currentTicker === ticker) {
			return;
		}

		this.privateVars.animating = true;

		const currentButtonHtml = document.querySelector<HTMLElement>(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataButtonCls}-${this.privateVars.currentTicker}`) as HTMLElement;
		const nextButtonHtml = document.querySelector<HTMLElement>(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataButtonCls}-${ticker}`) as HTMLElement;

		currentButtonHtml.classList.remove(this.publicVars.cssId.buttonPrimaryActiveCls?.substring(1) || '');
		nextButtonHtml.classList.add(this.publicVars.cssId.buttonPrimaryActiveCls?.substring(1) || '');


		gsap.to(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataAreaCls}-${this.privateVars.currentTicker}`, {
			duration: 0.1,
			opacity: 0,
			onComplete: () => {
				currentAreaHtml.classList.remove(this.publicVars.cssId?.quoteDataAreaActiveCls?.substring(1) || '');
				nextAreaHtml.classList.add(this.publicVars.cssId?.quoteDataAreaActiveCls?.substring(1) || '');
				nextAreaHtml.style.opacity = '0';
				gsap.to(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataAreaCls}-${ticker}`, {
					duration: 0.2,
					opacity: 1,
					onComplete: () => {
						this.privateVars.currentTicker = ticker;
						this.privateVars.animating = false;
						nextAreaHtml.removeAttribute('style');
					}
				});
			}
		});
	}

	async updateStockData(date: string | null) {
		if(!this.publicVars.apiStockEndpoint) {
			return;
		}

		if(!date) {
			this.handleLoadingStateHelper();
			return;
		}

		try {
			const result = await fetch(`${this.publicVars.apiStockEndpoint}/${date}`, {});

			if (!result.ok) {
				this.handleLoadingStateHelper();
				return;
			}

			const data: {
				data: {
					metadata: {
						selected_date_canada: string;
					}
					plsrv: {
						days_open: string;
						closing_price: string;
						intraday_low: string;
						intraday_high: string;
						volume: string;
						volume_formatted: string;
					},
					plsrl: {
						days_open: string;
						closing_price: string;
						intraday_low: string;
						intraday_high: string;
						volume: string;
						volume_formatted: string;
					},
					psrhf: {
						days_open: string;
						closing_price: string;
						intraday_low: string;
						intraday_high: string;
						volume: string;
						volume_formatted: string;
					}
				}
			} = await result.json();

			this.handleLoadingStateHelper();

			const stockDataQuoteDataDaysOpenPlsrlHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataDaysOpen}-${this.privateVars.tickers.plsrl}`);
			const stockDataQuoteDataClosingPricePlsrlHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataClosingPriceCls}-${this.privateVars.tickers.plsrl}`);
			const stockDataQuoteDataIntradayLowPlsrlHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataIntradayLowCls}-${this.privateVars.tickers.plsrl}`);
			const stockDataQuoteDataIntradayHighPlsrlHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataIntradayHighCls}-${this.privateVars.tickers.plsrl}`);
			const stockDataQuoteDataVolumePlsrlHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataVolumeCls}-${this.privateVars.tickers.plsrl}`);

			if(stockDataQuoteDataDaysOpenPlsrlHtml) {
				stockDataQuoteDataDaysOpenPlsrlHtml.innerHTML = data.data.plsrl.days_open ? '£' + parseFloat(data.data.plsrl.days_open) : '-';
			}

			if(stockDataQuoteDataClosingPricePlsrlHtml) {
				stockDataQuoteDataClosingPricePlsrlHtml.innerHTML = data.data.plsrl.closing_price ? '£' + parseFloat(data.data.plsrl.closing_price) : '-';
			}

			if(stockDataQuoteDataIntradayLowPlsrlHtml) {
				stockDataQuoteDataIntradayLowPlsrlHtml.innerHTML = data.data.plsrl.intraday_low ? '£' + parseFloat(data.data.plsrl.intraday_low) : '-';
			}

			if(stockDataQuoteDataIntradayHighPlsrlHtml) {
				stockDataQuoteDataIntradayHighPlsrlHtml.innerHTML = data.data.plsrl.intraday_high ? '£' + parseFloat(data.data.plsrl.intraday_high): '-';
			}

			if(stockDataQuoteDataVolumePlsrlHtml) {
				stockDataQuoteDataVolumePlsrlHtml.innerHTML = data.data.plsrl.volume_formatted ? '' + data.data.plsrl.volume_formatted : '-';
			}

			const stockDataQuoteDataDaysOpenPlsrvHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataDaysOpen}-${this.privateVars.tickers.plsrv}`);
			const stockDataQuoteDataClosingPricePlsrvHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataClosingPriceCls}-${this.privateVars.tickers.plsrv}`);
			const stockDataQuoteDataIntradayLowPlsrvHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataIntradayLowCls}-${this.privateVars.tickers.plsrv}`);
			const stockDataQuoteDataIntradayHighPlsrvHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataIntradayHighCls}-${this.privateVars.tickers.plsrv}`);
			const stockDataQuoteDataVolumePlsrvHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataVolumeCls}-${this.privateVars.tickers.plsrv}`);

			if(stockDataQuoteDataDaysOpenPlsrvHtml) {
				stockDataQuoteDataDaysOpenPlsrvHtml.innerHTML = data.data.plsrv.days_open ? '$' + parseFloat(data.data.plsrv.days_open) : '-';
			}

			if(stockDataQuoteDataClosingPricePlsrvHtml) {
				stockDataQuoteDataClosingPricePlsrvHtml.innerHTML = data.data.plsrv.closing_price ? '$' + parseFloat(data.data.plsrv.closing_price) : '-';
			}

			if(stockDataQuoteDataIntradayLowPlsrvHtml) {
				stockDataQuoteDataIntradayLowPlsrvHtml.innerHTML = data.data.plsrv.intraday_low ? '$' + parseFloat(data.data.plsrv.intraday_low) : '-';
			}

			if(stockDataQuoteDataIntradayHighPlsrvHtml) {
				stockDataQuoteDataIntradayHighPlsrvHtml.innerHTML = data.data.plsrv.intraday_high ? '$' + parseFloat(data.data.plsrv.intraday_high) : '-';
			}

			if(stockDataQuoteDataVolumePlsrvHtml) {
				stockDataQuoteDataVolumePlsrvHtml.innerHTML = data.data.plsrv.volume_formatted ? '' + data.data.plsrv.volume_formatted : '-';
			}

			const stockDataQuoteDataDaysOpenPsrhfHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataDaysOpen}-${this.privateVars.tickers.psrhf}`);
			const stockDataQuoteDataClosingPricePsrhfHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataClosingPriceCls}-${this.privateVars.tickers.psrhf}`);
			const stockDataQuoteDataIntradayLowPsrhfHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataIntradayLowCls}-${this.privateVars.tickers.psrhf}`);
			const stockDataQuoteDataIntradayHighPsrhfHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataIntradayHighCls}-${this.privateVars.tickers.psrhf}`);
			const stockDataQuoteDataVolumePsrhfHtml = document.querySelector(`${this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataVolumeCls}-${this.privateVars.tickers.psrhf}`);

			if(stockDataQuoteDataDaysOpenPsrhfHtml) {
				stockDataQuoteDataDaysOpenPsrhfHtml.innerHTML = data.data.psrhf.days_open ? '$' + parseFloat(data.data.psrhf.days_open) : '-';
			}

			if(stockDataQuoteDataClosingPricePsrhfHtml) {
				stockDataQuoteDataClosingPricePsrhfHtml.innerHTML = data.data.psrhf.closing_price ? '$' + parseFloat(data.data.psrhf.closing_price) : '-';
			}

			if(stockDataQuoteDataIntradayLowPsrhfHtml) {
				stockDataQuoteDataIntradayLowPsrhfHtml.innerHTML = data.data.psrhf.intraday_low ? '$' + parseFloat(data.data.psrhf.intraday_low) : '-';
			}

			if(stockDataQuoteDataIntradayHighPsrhfHtml) {
				stockDataQuoteDataIntradayHighPsrhfHtml.innerHTML = data.data.psrhf.intraday_high ? '$' + parseFloat(data.data.psrhf.intraday_high) : '-';
			}

			if(stockDataQuoteDataVolumePsrhfHtml) {
				stockDataQuoteDataVolumePsrhfHtml.innerHTML = data.data.psrhf.volume_formatted ? '' + data.data.psrhf.volume_formatted : '-';
			}

			const stockInfoQuoteQuoteDataDisclaimerItemInnerHtml = document.querySelector(this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataDisclaimerItemInnerCls || '')

			if(stockInfoQuoteQuoteDataDisclaimerItemInnerHtml) {
				stockInfoQuoteQuoteDataDisclaimerItemInnerHtml.innerHTML = data.data.metadata.selected_date_canada;
			}

		} catch(e) {
			this.handleLoadingStateHelper();
			return;
		}
	}

	handleLoadingStateHelper(isLoading = false) {
		const quoteDataInnerHtml = document.querySelector(this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataInnerCls || '');
		const quoteDataButtonsWrapperHtml = document.querySelector(this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataButtonsWrapperCls || '');
		const quoteLookupDateDataButtonsWrapperHtml = document.querySelector(this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteLookupDateDataButtonsWrapperCls || '');
		const quoteDataDisclaimerHtml = document.querySelector(this.publicVars.cssId.investorsStockInfoHistoricalQuoteQuoteDataDisclaimerCls || '') as HTMLElement;

		if(!quoteDataInnerHtml || !quoteDataButtonsWrapperHtml || !quoteLookupDateDataButtonsWrapperHtml || !quoteDataDisclaimerHtml) {
			return;
		}

		if(isLoading) {
			quoteDataInnerHtml.classList.add(this.publicVars.cssId?.quoteDataInnerLoadingCls?.substring(1) || '');
			quoteDataButtonsWrapperHtml.classList.add(
				this.publicVars.cssId?.dataSelectorButtonsButtonsWrapperLoadingCls?.substring(1) || '');
			quoteLookupDateDataButtonsWrapperHtml.classList.add(
				this.publicVars.cssId?.dataSelectorButtonsButtonsWrapperLoadingCls?.substring(1) || '');
			this.privateVars.animating = true;

			quoteDataDisclaimerHtml.style.opacity = '0.1';
		} else {
			quoteDataInnerHtml.classList.remove(this.publicVars.cssId?.quoteDataInnerLoadingCls?.substring(1) || '');
			quoteDataButtonsWrapperHtml.classList.remove(
				this.publicVars.cssId?.dataSelectorButtonsButtonsWrapperLoadingCls?.substring(1) || '');
			quoteLookupDateDataButtonsWrapperHtml.classList.remove(
				this.publicVars.cssId?.dataSelectorButtonsButtonsWrapperLoadingCls?.substring(1) || '');
			this.privateVars.animating = false;

			quoteDataDisclaimerHtml.style.opacity = '1';
		}
	}

}

export default HistoricalQuote;